import { map, first, size } from "lodash";
import { getToken } from "@/services/utils";

export const getFileUrl = url => {
  const token = `token=${getToken()}`;
  return `${url}?${token}`;
};

export const forceFileDownload = downloadUrl => {
  const link = document.createElement("a");
  link.href = downloadUrl;
  document.body.appendChild(link);
  link.click();
};

export const convertBlobFileToBase64 = blob => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};

export const getFilesFromUrls = async files => {
  if (!size(files)) {
    return [];
  }
  const convertedFiles = [];
  for (let index = 0; index < size(files); index++) {
    const file = files[index];
    const fileResponse = await fetch(getFileUrl(file.url));
    const blob = await fileResponse.blob();
    convertedFiles.push({
      ...file,
      data: new File([blob], file.fileName)
    });
  }
  return convertedFiles;
};

export const getFileTypesName = fileTypes => {
  const convertedFileTypes = map(fileTypes, fileType => {
    switch (fileType) {
      case "application/pdf":
        return "PDF";
      case "image/*":
        return "image";
      default:
        return fileType;
    }
  });
  const prefix = first(convertedFileTypes) === "image" ? "an" : "a";
  return `${prefix} ${convertedFileTypes.join(", ")}`;
};

export const getFilePreviewSettings = async file => {
  if (file.url) {
    return {
      src: getFileUrl(file.url),
      title: file.fileName
    };
  }
  // adjust base64 data if file doesn't have url
  const base64Data = await convertBlobFileToBase64(file.data);
  return {
    src: base64Data,
    title: file.name
  };
};
